import type { WebRouter } from '@duke-hq/svc-support/trpc/clients/web';
import { createTRPCReact, type CreateTRPCReact } from '@trpc/react-query';

export const trpc: CreateTRPCReact<WebRouter, unknown> = createTRPCReact<WebRouter>();

export type SupportChatTrpcClient = typeof trpc;
